import { useState } from 'react';
import { TextField, Checkbox, FormControlLabel, InputAdornment } from '@material-ui/core';
import { toast } from 'react-toastify';
import Axios from 'helpers/Interceptor';
import { InputContainer, useStyles } from '../../../../components/shareable/Modal/styles';
import { clsx } from 'modules/Utils';
import { localStyles } from './EditWebsiteSlugModal/styles';
import ModalSymphony from 'elements/ModalSymphony';
import useCurrentBrand, { BrandExistsState } from 'Hooks/useCurrentBrand';

interface EditBrandSlugModalProps {
    open: boolean;
    closeModal: () => void;
}

const EditBrandSlugModal = ({
    open,
    closeModal: closeModalProp,
}: EditBrandSlugModalProps) => {
    const classes = useStyles();
    const localClasses = localStyles()

    const { 
        currentBrand, 
        getBrand 
    } = useCurrentBrand() as BrandExistsState;
    const brandId = currentBrand.id;
    const brandSlug = currentBrand.slug;

    const [newSlug, setNewSlug] = useState<string>(brandSlug);
    const [updatePreSaveCampaigns, setUpdatePreSaveCampaigns] = useState<boolean>(false);
    const [slugError, setSlugError] = useState<string>('');
    const [isLoadingEditSlug, setLoadingEditSlug] = useState<boolean>(false);

    const closeModal = () => {
        setNewSlug(brandSlug);
        setUpdatePreSaveCampaigns(false);
        setSlugError('');
        closeModalProp();
    }

    const handleSlugChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewSlug(event.target.value);
        if (event.target.value === '') {
            setSlugError('Slug cannot be empty.');
        } else {
            setSlugError('');
        }
    };

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUpdatePreSaveCampaigns(event.target.checked);
    };

    const handleConfirmEditSlug = async () => {
        if (!newSlug) {
            setSlugError('Slug cannot be empty.');
            return;
        }

        setLoadingEditSlug(true);

        try {
            await Axios.post(`/brand/${brandId}/update-slug`, {
                newSlug: newSlug,
                updateActivePreSaveCampaigns: updatePreSaveCampaigns
            });
            toast.success('Brand slug updated successfully!');
            await getBrand();
            closeModal();
        } catch (error) {
            setSlugError('Failed to update slug. It might be already in use or there was another issue.');
        } finally {
            setLoadingEditSlug(false);
        }
    };


    return (
        <ModalSymphony
            isOpen={open}
            onClose={closeModal}
            className="adminEditBrandSlugModal"
            title="Admin: Edit Brand Slug"
            subtitle={`Edit the brand slug used in URLs (currently "${brandSlug}"). Be careful, as changing the slug will affect all related URLs.`}

            onClickButtonRight={handleConfirmEditSlug}
            buttonRightIsLoading={isLoadingEditSlug}
            buttonRightText="Update Slug"
            buttonRightDisabled={isLoadingEditSlug || !newSlug}
            buttonRightLoadingText="Updating..."

            onClickButtonLeft={closeModal}
            buttonLeftText="Cancel"
            buttonLeftDisabled={isLoadingEditSlug}
        >
            <InputContainer>
                <TextField
                    InputProps={{
                        classes: { root: classes.inputBorder },
                        startAdornment: <InputAdornment
                            position="start"
                            className={localClasses.inputAdornment}>https://symphony.to/</InputAdornment>,
                    }}
                    className={clsx(localClasses.textField, classes.textField)}
                    variant="outlined"
                    fullWidth
                    type="text"
                    value={newSlug}
                    onChange={handleSlugChange}
                    error={!!slugError}
                    helperText={slugError}

                />
                <FormControlLabel
                    control={<Checkbox checked={updatePreSaveCampaigns} onChange={handleCheckboxChange} />}
                    label="Do you also want to update URLs for any active pre-save campaigns?"
                />
            </InputContainer>
        </ModalSymphony>
    );
};

export default EditBrandSlugModal;
